import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const DeleteConfirmationModal = ({ 
  show, 
  handleClose, 
  handleDelete, 
  message,
  title,
  buttontext,
}) => {
    const a = 5;
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          {buttontext}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteConfirmationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    title: PropTypes.string,
    buttontext: PropTypes.string,
  };

 // Set default props
DeleteConfirmationModal.defaultProps = {
  title: 'Confirm Deletion',
  buttontext: 'Delete',
};

export default DeleteConfirmationModal;

